const loginTab = document.querySelectorAll('.login__section-tab')
const loginContent = document.querySelectorAll('.login__section-tab-content')
const loginTitle = document.querySelectorAll('.login__section-title');
const loginForgot = document.querySelector('.login__section-forgot');
const loginRecover = document.querySelector('.login__recover');
const loginInfo = document.querySelector('.login__section-info');
const loginForgotCansel = document.querySelector('.login__recover .login__section-forgot');


loginForgot.addEventListener("click", ()=>{
    loginRecover.classList.add("is-show")
    loginInfo.style.display = 'none'
})

loginForgotCansel.addEventListener("click", ()=>{
    loginRecover.classList.remove("is-show")
    loginInfo.style.display = 'block'
})

loginTab?.forEach(tab =>{
    tab.addEventListener("click", () =>{clickTab(tab)})
})

function clickTab(tab) {
    loginContent?.forEach(content =>{
        if (tab.dataset.id === content.dataset.id) {
            removeContent(loginContent)
            removeContent(loginTab)
            tab.classList.add('active')
            content.classList.add('active')
        }
    })
    loginTitle?.forEach(title =>{
        if (tab.dataset.id === title.dataset.id) {
            removeContent(loginTitle)
            removeContent(loginTab)
            tab.classList.add('active')
            title.classList.add('active')
        }
    })
}

function removeContent(array) {
    array.forEach(item => {
        item.classList.remove("active")
    });
}